import axios from './axios';

const QrServices = {
    getAllMenuQrById: async (menuItemId) => {
        try {
            const response = await axios.get(`/menu-qr/${menuItemId}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    getAllMenuQr: async () => {
        try {
            const response = await axios.get(`/menu-qr`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    createQr: async (payload) => {
        try {
            const response = await axios.post(`/menu-qr`, payload);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    generateQRCode: async (id, payload) => {
        try {
            const response = await axios.put(`/qr/type/${id}`, payload);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    getGeneratedQR: async (id) => {
        try {
            const response = await axios.get(`/qr/type/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    newCodeGeneration: async (payload) => {
        try {
            const response = await axios.post(`/qr`, payload);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    deleteQr: async(id) => {
        try {
            const response = await axios.delete(`/menu-qr/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
    deleteQrType: async(type) => {
        try {
            const response = await axios.delete(`/qr/type/${type}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        } 
    },
};

export default QrServices;